import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { LDClientService } from './ldclient.service';

export const ldClientResolver: ResolveFn<boolean> = () => {
  const ldClient = inject(LDClientService);
  return ldClient.isInitializing().pipe(
    filter((val: boolean) => !val),
    take(1)
  );
};
